import type { GenerateAttendanceProtocolResponse } from '../../types/vida/protocol/protocolType';
import { VIDA_PROTOCOL_ROUTES } from '../requestsService';

function buildQueryString(params: Record<string, string | number | undefined>): string {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== '') {
      search.append(key, String(value));
    }
  });
  const qs = search.toString();
  return qs ? `?${qs}` : '';
}

export class ProtocolService {
  private fetch: <T>(endpoint: string, options?: RequestInit) => Promise<T>;

  constructor(fetch: <T>(endpoint: string, options?: RequestInit) => Promise<T>) {
    this.fetch = fetch;
  }

  /**
   * Generates Vida attendance protocol (GET gerar-protocolo-atendimento).
   * @param identContrato - Contract id (required)
   * @param codUsuarioInclusao - User code for inclusion (required)
   */
  async getGenerateAttendanceProtocol(
    identContrato: number,
    codUsuarioInclusao: number,
  ): Promise<GenerateAttendanceProtocolResponse> {
    const url =
      VIDA_PROTOCOL_ROUTES.GET_GENERATE_PROTOCOL +
      buildQueryString({ identContrato, codUsuarioInclusao });
    const response = await this.fetch<GenerateAttendanceProtocolResponse>(url, { method: 'GET' });
    return response;
  }
}
